import React, {FC, useState} from 'react'
import {Button, Icon, Search, Stack} from '@mdsol/onex-design'
import {useSelector} from 'react-redux'
import {select_gridSession_filters_searchQuery} from 'redux/databases/selectors'
import {databasesAC, refreshDatabases, syncDb} from 'redux/databases/databases.duck'
import {customMessageRequest, genericRequestError} from 'redux/toast/toast.duck'
import {useAppDispatch} from 'redux/config'
import {useRouter} from '@uirouter/react'
import {select_auth_user} from 'redux/auth/selectors'

const GridControl: FC = () => {
  const dispatch = useAppDispatch()
  const router = useRouter()

  const {isAdmin} = useSelector(select_auth_user)
  const defaultSearchQuery = useSelector(select_gridSession_filters_searchQuery)
  const [searchQuery, setSearchQuery] = useState(defaultSearchQuery)

  const handleSearchQueryChange = value => {
    setSearchQuery(value)
  }

  const handleKeyPress = target => {
    if(target.key === 'Enter') {
      const filters = {searchQuery: searchQuery}
      dispatch(refreshDatabases(router, filters))
    }
  }

  const handleClear = () => {
    const filters = {searchQuery: ''}
    dispatch(refreshDatabases(router, filters))
  }

  const handleRefresh = async () => {
    try {
      await router.stateService.reload()
      dispatch(customMessageRequest('information', 'Databases have been refreshed.', 1000))
    } catch (err) {
      dispatch(genericRequestError())
    }
  }

  const handleDbSync = () => {
    dispatch(syncDb(router))
  }

  const handleBulkEdit = () => {
    dispatch(databasesAC.hideDatabaseDetails())
    dispatch(databasesAC.databaseIdToCopyApplied(''))
    dispatch(databasesAC.showBulkEditPanel())
  }

  return (
    <div className='onex-data-grid-control' >
      <div className='onex-data-grid-control__actions'>
        <Stack className='buttons-panel' direction='horizontal' gap={2}>
          <Button
            className='bulkedit-btn'
            dataTestId='bulkedit-button'
            onClick={handleBulkEdit}
            size='sm'
            leadingIcon={<Icon key='key-bulk-edit-leading-icon'>edit_note</Icon>}
            hidden={!isAdmin}
          >
            Bulk Edit
          </Button>
          
          <Button
            className='sync-btn'
            dataTestId='dbsync-button'
            onClick={handleDbSync}
            size='sm'
            leadingIcon={<Icon key='key-database-sync-leading-icon'>sync</Icon>}
          >
            Sync
          </Button>

          <Button
            className='refresh-button databases-refresh'
            dataTestId='db-refresh-button'
            onClick={handleRefresh}
            size='sm'
            leadingIcon={<Icon key='key-jobs-filters-panel-refresh-leading-icon'>refresh</Icon>}
          >
            Refresh
          </Button>
        </Stack>

        <Search
          placeholder='Search'
          showClearBtn
          dataTestId='search-field'
          value={searchQuery}
          onChange={value => handleSearchQueryChange(value)}
          onKeyPress={handleKeyPress}
          onClear={handleClear}
        />
      </div>
    </div>
  )
}

export default GridControl
